import { Accordion } from '@/components/Accordion/Accordion';
import { MagicWand01Icon } from '@/components/icons/MagicWand01Icon';
import { DeliverableCard } from '@/components/layout/DeliverableCard/DeliverableCard';
import { HorizontalCarousel } from '@/components/layout/HorizontalCarousel/HorizontalCarousel';
import { COLORS } from '@/styles/tokens/colors';

import { useCreatableMemoPromptTypes } from '../hooks/useCreatableMemoPromptTypes';
import {
  CreatableMemoPromptType,
  MEMO_PROMPT_CONFIG,
} from '../memos.constants';

interface GenerateMemoSectionProps {
  onSelectPromptType?: (promptType: CreatableMemoPromptType) => void;
}

export function GenerateMemoSection({
  onSelectPromptType,
}: GenerateMemoSectionProps) {
  const visibleMemoPromptTypes = useCreatableMemoPromptTypes();

  const memoTypeCards = visibleMemoPromptTypes.map((memoPromptType) => {
    const memoPromptConfig = MEMO_PROMPT_CONFIG[memoPromptType];

    return (
      <DeliverableCard
        key={memoPromptType}
        onClick={() => {
          onSelectPromptType?.(memoPromptType);
        }}
        dataTestId={`generate-memo-card-${memoPromptType}`}
        title={memoPromptConfig.title}
        description={memoPromptConfig.description}
        icon={memoPromptConfig.Icon}
        sizeVariant="small"
        hideBadge
      />
    );
  });
  return (
    <Accordion
      isDefaultExpanded
      variant="filled"
      leftAdornment={<MagicWand01Icon color={COLORS.NAVY[300]} />}
      title="Generate a new memo"
      withDivider={false}
    >
      <HorizontalCarousel items={memoTypeCards} numVisibleItems={4} gap={16} />
    </Accordion>
  );
}
